/* @jsxImportSource react */
import { CustomerRatingsCount } from '../../CustomerRatingsCount/CustomerRatingsCount';

export type CustomerRatingMeterLabelProps = {
  ratingsCount: number;
};

/**
 * The CustomerRatingMeterCount component displays a count for the customer rating meter
 *
 * @param ratingsCount - The number of ratings to display
 * @returns A React component rendering the customer rating meter count
 */

export const CustomerRatingMeterCount = ({ ratingsCount }: CustomerRatingMeterLabelProps) => (
  <div className="text-center">
    <CustomerRatingsCount ratingsCount={ratingsCount} isLinked={ratingsCount > 0} />
  </div>
);
